import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import MenuSectionsBarItems from 'bento-ordering/menus/components/MenuSectionsBarItems';

const MenuSectionsBar = ({ menu }) => {
  if (menu.isFetching) {
    return null;
  }

  return <MenuSectionsBarItems menu={menu} />;
};

const mapStateToProps = state => {
  return {
    menu: state.menu,
    googleLoaded: state.libraryLoad.google
  };
};

MenuSectionsBar.propTypes = {
  menu: PropTypes.object
};

export default connect(mapStateToProps)(MenuSectionsBar);
